/**
 * analytics.js - Plausible + GTM event tracking for comparator verticals.
 * No PII. Safe no-op if Plausible is not loaded.
 *
 * Events:
 *   cmp_view          { vertical }
 *   cmp_filter_toggle { vertical, filter }
 *   cmp_sort_change   { vertical, sort }
 *   cmp_open_detail   { vertical, id }
 *   cmp_add_compare   { vertical, id }
 *   cmp_run_compare   { vertical, count }
 *   cmp_click_apply   { vertical, id, domain }
 */

import { gtmOfferClick, gtmComparatorUsed } from '../../utils/gtm';

function fire(eventName, props) {
  if (typeof window !== 'undefined' && typeof window.plausible === 'function') {
    window.plausible(eventName, { props });
  }
}

export function trackView(vertical) {
  fire('cmp_view', { vertical });
  gtmComparatorUsed({ vertical, action: 'view', detail: vertical });
}

export function trackFilterToggle(vertical, filter) {
  fire('cmp_filter_toggle', { vertical, filter });
  fire('Filter Used', { category: vertical });
  gtmComparatorUsed({ vertical, action: 'filter', detail: filter });
}

export function trackSortChange(vertical, sort) {
  fire('cmp_sort_change', { vertical, sort });
  gtmComparatorUsed({ vertical, action: 'sort', detail: sort });
}

export function trackOpenDetail(vertical, id) {
  fire('cmp_open_detail', { vertical, id });
  gtmComparatorUsed({ vertical, action: 'open_detail', detail: id });
}

export function trackAddCompare(vertical, id) {
  fire('cmp_add_compare', { vertical, id });
  gtmComparatorUsed({ vertical, action: 'add_compare', detail: id });
}

export function trackRunCompare(vertical, count) {
  fire('cmp_run_compare', { vertical, count: String(count) });
  gtmComparatorUsed({ vertical, action: 'run_compare', detail: String(count) });
}

export function trackClickApply(vertical, id, url) {
  let domain = '';
  try { domain = new URL(url).hostname; } catch { /* ignore */ }
  fire('cmp_click_apply', { vertical, id, domain });
  fire('Outbound Offer Click', { bank: id, product: vertical });
  gtmOfferClick({ product: id, provider: domain, vertical, url });
}
